import { brandConstants, isBranchEnv } from 'brand-config';

// The record types the condensed layout's Search page offers, in chip order, behind the same gates as the
// classic page's tabs. Branch Plus is internal-only: it is what only Branch staff see.
export const visibleSearchTypes = ({ canEdit, canQuote, viewOnly, isInternalAgent }) =>
  [
    { key: 'customers', label: 'Customers', to: '/search/customers', resultsKey: 'customersResults' },
    { key: 'policies', label: 'Policies', to: '/search/policies', resultsKey: 'policiesResults' },
    ((canEdit && canQuote) || viewOnly) && {
      key: 'offers',
      label: 'Offers',
      to: '/search/offers',
      resultsKey: 'offersResults'
    },
    isInternalAgent &&
      isBranchEnv && {
        key: 'branchPlus',
        label: `${brandConstants.SHORT_NAME} Plus`,
        to: '/search/branch-plus',
        resultsKey: 'branchPlusPoliciesResults',
        internal: true
      }
  ].filter(Boolean);

export const ALL_RESULTS_ROUTE = '/search/all';
